import { useDispatch } from "react-redux";
import UploadFileZone from "./UploadFileZone";
import UploadTutorial from "./UploadTutorial";

import React, { useState } from "react";
import { start } from "../../../../store/loadingSlice";

const UploadFileDrawer = ({ openSideBar, handleDrawerClose }) => {
  const dispatch = useDispatch();

  const viewedTipsPersistance = localStorage.getItem("viewedTips");

  const [isTutorialAlreadyVisualized, setIsTutorialAlreadyVisualized] =
    useState(viewedTipsPersistance === "true");

  dispatch(start());

  if (!isTutorialAlreadyVisualized) {
    return (
      <UploadTutorial
        openSideBar={openSideBar}
        handleDrawerClose={handleDrawerClose}
        setIsTutorialAlreadyVisualized={setIsTutorialAlreadyVisualized}
      />
    );
  }

  return (
    <UploadFileZone
      openSideBar={openSideBar}
      handleDrawerClose={handleDrawerClose}
    />
  );
};

export default UploadFileDrawer;
